<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="filter" :model="filter"  :label-width="100" label-position="right" @submit.native.prevent>
        <Row type="flex">
          <Col v-bind="grid">
            <FormItem label="搜索内容："  label-for="key">
              <Input search enter-button placeholder="请输入耳标编号搜索" clearable v-model="filter.search" @on-search="search" @on-clear="searchClear">
              </Input>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="牛只类别："  label-for="key">
              <Select v-model="filter.cattle_type_id" class="perW100" @on-change="select">
                <Option :value="0">全部</Option>
                <Option v-for="(item, key) in cattleTypeList" :value="key" :key="key">{{item}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="牛只品种："  label-for="key">
              <Select v-model="filter.cattle_variety_id" class="perW100" @on-change="select">
                <Option :value="0">全部</Option>
                <Option v-for="(item, key) in cattleVarietyList" :value="key" :key="key">{{item}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="繁殖状态："  label-for="key">
              <Select v-model="filter.status" class="perW100" @on-change="select">
                <Option :value="0">全部</Option>
                <Option :value="1">复检+</Option>
                <Option :value="2">复检-</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="临产筛选："  label-for="key">
              <Select v-model="filter.parturition" class="perW100" @on-change="select">
                <Option :value="0">全部</Option>
                <Option :value="1">临产(15天内)</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="创建时间：" prop="key" label-for="key">
              <DatePicker type="daterange" :value="filter.ctime" confirm placeholder="请选择查询时间段" style="width: 100%" @on-ok="dateOk" @on-change="dateChange" @on-clear="dateClear"></DatePicker>
            </FormItem>
          </Col>
          <Col style="margin-left: 20px">
            <Button type="primary" icon="ios-cloud-download-outline" @click="exportTableData" :loading="exportLoading">报告导出</Button>
          </Col>
        </Row>
        <Row type="flex" style="flex-wrap: nowrap;justify-content: space-between;margin: 20px 20px 0 20px">

          <Col style="margin: 0 10px">
            <Button type="primary" icon="md-add" @click="add">添加</Button>
          </Col>

        </Row>
      </Form>

      <Table :columns="columns" stripe  :data="tableData" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >

        <template slot-scope="{ row, index }" slot="action">
          <a @click="info(row.cattle_breed_log_id)">查看</a>
          <Divider type="vertical" />
          <a @click="edit(row.cattle_breed_log_id)">编辑</a>
          <Divider type="vertical" />
          <a @click="del(row.cattle_breed_log_id)">删除</a>
        </template>

      </Table>
      <Page :total="tableCount" :current="filter.page" :page-size="filter.limit" class="acea-row row-right page" show-total  @on-change="changePage"></Page>
    </Card>
  </div>
</template>

<script>
import { cattleBreedLogListApi, cattleBreedLogDelApi } from '@/api/cattleFarm/cattleBreedLog'
import { cattleTypeAllApi } from '@/api/cattleFarm/cattleType'
import { cattleVarietyAllApi } from '@/api/cattleFarm/cattleVariety'

export default {
  name: 'cattleBreedLogList',
  inject: ['reload'],
  data () {
    return {
      grid: {
        xs: 24,
        sm: 24,
        md: 12,
        lg: 7,
        xl: 7
      },
      filter: {
        page: 1,
        limit: 10,
        ctime: [],
        export: 0,
        search: '',
        status: 0,
        cattle_type_id: 0,
        cattle_variety_id: 0,
        parturition: 0,
      },
      cattleTypeList: [],
      cattleVarietyList: [],
      tableData: [],
      tableCount: 0,
      loading: false,
      exportLoading: false,
      columns: [
        {
          title: '牛只类别',
          key: 'cattle_type_name',
          minWidth: 100
        },
        {
          title: '牛只品种',
          key: 'cattle_variety_name',
          minWidth: 100
        },
        {
          title: '耳标编号',
          key: 'tag_sn',
          minWidth: 180
        },
        {
          title: '怀孕日期',
          key: 'pregnancy_date',
          minWidth: 100
        },
        {
          title: '预产期预测',
          minWidth: 100,
          render: (h, params) => {
            // 临产状态parturition_status 判断如果临产状态为0预产期正常颜色 如果为1 预产期文字颜色为红色
            const color = params.row.parturition_status === 0 ? '#515a6e' : '#f00';
            return h('span', { style: { color } }, params.row.due_date);
          }
        },
        {
          title: '当前胎次',
          key: 'num',
          minWidth: 100
        },
        {
          title: '繁殖状态',
          key: 'status_msg',
          minWidth: 100
        },
        {
          title: '繁育数量',
          key: 'child_num',
          minWidth: 100
        },
        {
          title: '创建时间',
          key: 'ctime',
          minWidth: 150
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          minWidth: 150
        }

      ]
    }
  },
  created () {
    this.loadTableData()
    this.loadCattleTypeData()
    this.loadCattleVarietyData()
  },
  methods: {
    loadTableData () {
      this.loading = true
      this.filter.export = 0
      cattleBreedLogListApi(this.filter).then(res => {
        this.tableData = res.data.list
        this.tableCount = res.data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 牛类别
    loadCattleTypeData() {
      cattleTypeAllApi().then(res => {
        if (res.code === 200) {
          this.cattleTypeList = res.data
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    // 牛品种
    loadCattleVarietyData() {
      cattleVarietyAllApi().then(res => {
        if (res.code === 200) {
          this.cattleVarietyList = res.data
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changePage (status) {
      this.filter.page = status
      this.loadTableData()
    },
    // 搜索
    search () {
      this.filter.page = 1
      this.loadTableData()
    },
    // 搜索清空
    searchClear () {
        this.filter.search = ''
        this.loadTableData()
    },
    // 下拉选择
    select(value){
      this.loadTableData()
    },
    // 选择时间
    dateOk(){
      this.loadTableData()
    },
    // 时间切换
    dateChange(dateArr){
      this.filter.ctime = dateArr
    },
    // 时间清空
    dateClear(){
      this.filter.ctime = []
      this.loadTableData()
    },
    // 数据导出
    exportTableData () {
      this.exportLoading = true
      this.filter.export = 1
      cattleBreedLogListApi(this.filter).then(res => {
        this.exportLoading = false
        if(res.code === 200){
          if (res.data.url){
            window.open(res.data.url)
          }else{
            this.$Message.error('导出失败')
          }
        }else{
          this.exportLoading = false
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.exportLoading = false
        this.$Message.error(res.msg)
      })
    },
    // 添加
    add () {
      this.$router.push({ path: this.pathFormat(this.$route.path) })
    },
    // 详情
    info (id) {
      this.$router.push({ path: this.pathFormat(this.$route.path, 'info', id) })
    },
    // 编辑
    edit (id) {
      this.$router.push({ path: this.pathFormat(this.$route.path, 'edit', id) })
    },
    // 删除
    del (id) {
      this.$Modal.confirm({
        title: '提示',
        content: '确认删除？',
        onOk: () => {
          cattleBreedLogDelApi(id).then(res => {
            if (res.code === 200) {
              this.$Message.success('删除成功')
              this.reload()
            } else {
              this.$Message.error(res.msg)
            }
          }).catch(res => {
            this.$Message.error(res.msg)
          })
        }
      })
    },

  }
}
</script>
